import { render } from "./Erase.vue?vue&type=template&id=5eb4271b&scoped=true"
const script = {}

import "./Erase.vue?vue&type=style&index=0&id=5eb4271b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb4271b"]])

export default __exports__